var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Warranty50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M39 43L32.21 43 28.32 47.85 21.92 33 34.39 33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M27.18 33L20.68 47.85 16.79 43 10 43 14.61 33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M40.325,22.596c-0.547-0.993-0.547-2.198,0-3.191l0.262-0.476c0.855-1.555,0.333-3.509-1.187-4.428 l-0.465-0.282c-0.97-0.588-1.572-1.63-1.596-2.763l-0.012-0.544c-0.036-1.775-1.466-3.205-3.241-3.241l-0.544-0.012 c-1.134-0.023-2.177-0.626-2.763-1.596l-0.282-0.465c-0.919-1.519-2.873-2.042-4.428-1.187l-0.476,0.262 c-0.993,0.547-2.198,0.547-3.191,0l-0.475-0.261C20.372,3.557,18.419,4.08,17.5,5.599l-0.282,0.465 c-0.588,0.97-1.63,1.572-2.763,1.596l-0.544,0.012c-1.775,0.036-3.205,1.466-3.241,3.241l-0.012,0.544 c-0.023,1.134-0.626,2.177-1.596,2.763l-0.465,0.282c-1.518,0.919-2.042,2.873-1.187,4.428l0.262,0.476 c0.547,0.993,0.547,2.198,0,3.191l-0.261,0.475c-0.855,1.555-0.333,3.509,1.187,4.428l0.465,0.282 c0.97,0.588,1.572,1.63,1.596,2.763l0.012,0.544c0.036,1.775,1.466,3.205,3.241,3.241l0.544,0.012 c1.134,0.023,2.177,0.626,2.763,1.596l0.282,0.465c0.919,1.518,2.873,2.042,4.428,1.187l0.476-0.262 c0.993-0.547,2.198-0.547,3.191,0l0.476,0.262c1.555,0.855,3.509,0.333,4.428-1.187l0.282-0.465c0.588-0.97,1.63-1.572,2.763-1.596 l0.544-0.012c1.775-0.036,3.205-1.466,3.241-3.241l0.012-0.544c0.023-1.134,0.626-2.177,1.596-2.763l0.465-0.282 c1.518-0.919,2.042-2.873,1.187-4.428L40.325,22.596z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    d: "M23.999 9A12 12 0 1 0 23.999 33A12 12 0 1 0 23.999 9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M24,34.001c-7.168,0-13-5.832-13-13S16.831,8,24,8s13,5.832,13,13S31.168,34.001,24,34.001z M24,10 c-6.066,0-11,4.935-11,11s4.935,11,11,11s11-4.935,11-11S30.065,10,24,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Warranty50);
export default __webpack_public_path__ + "static/media/icons8-warranty-50.ceb75bd9c98a24a536f14ef356a6ac5d.svg";
export { ForwardRef as ReactComponent };